import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import { Area } from '@/enums/Area.enum';
import { LayerName } from '@/enums/LayerName.enum';

import data from '@/data/grid.data.json';

export const colorLayer = new VectorLayer({
	visible: true,
	source: new VectorSource({
		features: new GeoJSON().readFeatures(data, { featureProjection: 'EPSG:3857' }),
	}),
});

colorLayer.setProperties({ area: Area.COLOR, name: LayerName.COLOR });
